// extracted by mini-css-extract-plugin
export default {"panelHeader":"CaseManagement_panelHeader__jQ9zz","titleContainer":"CaseManagement_titleContainer__mnmQp","checkIcon":"CaseManagement_checkIcon__ZjnyY"};